/**
 * @generated SignedSource<<15ae548fc41234ddeac9496ed78f3910>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ArchiveProgramInput = {
  clientMutationId?: string | null | undefined;
  id: string;
};
export type ArchiveProgramMutation$variables = {
  input: ArchiveProgramInput;
};
export type ArchiveProgramMutation$data = {
  readonly archiveProgram: {
    readonly programId: string;
  } | null | undefined;
};
export type ArchiveProgramMutation = {
  response: ArchiveProgramMutation$data;
  variables: ArchiveProgramMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ArchiveProgramPayload",
    "kind": "LinkedField",
    "name": "archiveProgram",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "programId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ArchiveProgramMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ArchiveProgramMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "50f6e26989da0ad6e2304d6d17ffd785",
    "id": null,
    "metadata": {},
    "name": "ArchiveProgramMutation",
    "operationKind": "mutation",
    "text": "mutation ArchiveProgramMutation(\n  $input: ArchiveProgramInput!\n) {\n  archiveProgram(input: $input) {\n    programId\n  }\n}\n"
  }
};
})();

(node as any).hash = "2e66f2ad8ac2a3432db72c1680e517f3";

export default node;
